import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpHeaders, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { HttpModule } from '@angular/http';

import { HelpComponent } from './help.component';
import { HelpService } from './help.service';
import { HelpRoutingModule } from './help-routing.module';


@NgModule({ declarations: [
        HelpComponent
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HelpRoutingModule
        // HttpModule
    ], providers: [HelpService, provideHttpClient(withInterceptorsFromDi())] })
export class HelpModule { }
